<template>
  <div>
    <div :class="showTotal ? 'upper-part' : 'pack-up'" ref="ellipsis">
      <div
        class="abstract"
        ref="date"
        :style="{ maxHeight: showTotal ? '' : maxHeight, '--lineHeight': lineHeight + 'px' }"
      >
        <span class="content-date">
          {{ text }}
        </span>
        <div
          class="unfold"
          @click="toggleShowTotal"
          v-if="isShowTxt"
          :style="{ '--unfoldBackgroundImage': unfoldBackgroundImage }"
        >
          <p>{{ changeButton ? expandText : collapseText }}</p>
          <auth-img
            :src="changeButton ? downImg : upImg"
            fit="contain"
            style="width: 12px; height: 12px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import downImg from '@/assets/img/chat/agreement/down.png'
import upImg from '@/assets/img/chat/agreement/up.png'
import { nextTick } from 'vue'
import { ref, watch, onMounted, watchEffect, defineProps } from 'vue'

const props = defineProps({
  text: {
    type: String,
    default: '--'
  },
  rows: {
    type: Number,
    default: 1
  },
  expandText: {
    type: String,
    default: '展开'
  },
  collapseText: {
    type: String,
    default: '收起'
  },
  lineHeight: {
    type: Number,
    default: 22
  },
  unfoldBackgroundImage: {
    type: String,
    default: 'linear-gradient(90deg, #ffffff00 0%, #FFFFFF 22%)'
  }
})

const showTotal = ref(true)
const changeButton = ref(true)
const isShowTxt = ref(false)
const ellipsis = ref(null)
const date = ref(null)
const maxHeight = ref('')

const calculateText = () => {
  const height = props.rows * props.lineHeight + 'px'
  const txtHeight = ellipsis.value.offsetHeight
  maxHeight.value = height
  if (parseInt(txtHeight / props.lineHeight) <= props.rows) {
    isShowTxt.value = false
    showTotal.value = true
  } else {
    isShowTxt.value = true
    showTotal.value = false
  }
}

onMounted(() => {
  calculateText()
})

watch(
  () => props.text,
  () => {
    if (ellipsis.value) {
      nextTick(() => {
        calculateText()
      })
    }
  }
)
const toggleShowTotal = () => {
  console.log('是否展开' + showTotal.value)
  showTotal.value = !showTotal.value
  changeButton.value = !changeButton.value
}
</script>

<style lang="scss" scoped>
.upper-part {
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
  font-size: 14px;

  .abstract {
    line-height: var(--lineHeight);
    overflow: hidden;
    zoom: 1;

    .content-date {
      color: #1c1c1c;
    }
  }

  .unfold {
    float: right;
    display: flex;
    align-items: center;
    position: relative;

    p {
      margin-top: 0px;
      margin-bottom: 0px;
      color: #3f64ff;
      margin-right: 2px;
    }
  }
}

.pack-up {
  position: relative;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
  font-size: 14px;

  .abstract {
    max-height: v-bind(maxHeight);
    line-height: var(--lineHeight);
    overflow: hidden;

    .content-date {
      color: #1c1c1c;
      width: 100%;
    }

    .unfold {
      z-index: 100;
      outline: 0;
      position: absolute;
      right: 0;
      bottom: 0;
      width: 60px;
      background-image: var(--unfoldBackgroundImage);
      text-align: right;
      display: flex;
      align-items: center;

      p {
        margin: 0;
        color: #3f64ff;
        width: 46px;
        margin-right: 2px;
      }
    }
  }
}
</style>
